<!-- Bound to [open] rather than wrapped in @if: ams-dialog restores
     `body { overflow }` from its open→false transition, and it has no
     ngOnDestroy — destroying it while open would leave the whole app
     unscrollable for the rest of the session. -->
<ams-dialog
  [open]="isOpen()"
  title="Our Terms have been updated"
  [showCloseButton]="false"
  [closeOnBackdrop]="false"
  [closeOnEscape]="false"
  [hasCustomFooter]="true"
>
  <p class="legal-acceptance-gate__intro">
    Please review and accept the following to continue using Membora.
  </p>

  @if (needsTerms()) {
    <label class="legal-acceptance-gate__agreement">
      <input type="checkbox" [ngModel]="agreeTerms()" (ngModelChange)="agreeTerms.set($event)" />
      <span>
        I have read and agree to the
        <a [href]="termsUrl()" target="_blank" rel="noopener">Terms and Conditions</a>.
      </span>
    </label>
  }
  @if (needsPrivacy()) {
    <label class="legal-acceptance-gate__agreement">
      <input type="checkbox" [ngModel]="agreePrivacy()" (ngModelChange)="agreePrivacy.set($event)" />
      <span>
        I have read and agree to the
        <a [href]="privacyUrl()" target="_blank" rel="noopener">Privacy Policy</a>.
      </span>
    </label>
  }

  @if (errorMessage()) {
    <p class="legal-acceptance-gate__error">{{ errorMessage() }}</p>
  }

  <div slot="footer" class="legal-acceptance-gate__footer">
    <button
      type="button"
      class="legal-acceptance-gate__continue"
      [disabled]="!canContinue() || submitting()"
      (click)="onContinue()"
    >
      {{ submitting() ? 'Saving...' : 'Continue' }}
    </button>
  </div>
</ams-dialog>
